<sh-popover styleClass="account-panel" (opened)="onShow()">
  <div
    class="account-panel-current"
    *ngIf="identityService.identity as identity"
  >
    <div class="account-avatar account-avatar-lg">
      {{ initialsForCurrent() }}
    </div>
    <div class="account-panel-current-text">
      <div class="subtitle">
        {{ identity.givenName }} {{ identity.surname }}
      </div>
      <div class="meta">{{ identity.organisationName }}</div>
      <div class="meta">{{ identity.emailAddress }}</div>
    </div>
  </div>

  <sh-button
    *ngIf="profileRoute()"
    [routerLink]="profileRoute()"
    (click)="hide()"
    variant="outlined"
    size="sm"
    styleClass="account-panel-profile-button"
    label="shell.accountPanel.myProfile"
  ></sh-button>

  <ng-container *ngIf="otherAccounts.length">
    <div class="label account-panel-section-label">
      {{ 'shell.accountPanel.otherAccounts' | translate }}
    </div>
    <button
      type="button"
      class="account-panel-row"
      *ngFor="let account of otherAccounts"
      (click)="switchToAccount(account)"
    >
      <div class="account-avatar account-avatar-sm">
        {{ initialsFor(account) }}
      </div>
      <div class="account-panel-row-text">
        <div>{{ account.fullName }}</div>
        <div class="meta">{{ account.organisationName }}</div>
        <div class="meta">{{ account.emailAddress }}</div>
      </div>
    </button>
  </ng-container>

  <button
    type="button"
    class="account-panel-row account-panel-add"
    (click)="addAccount()"
  >
    <i class="fa-solid fa-plus"></i>
    {{ 'accounts.addAnotherAccount' | translate }}
  </button>

  <div class="account-panel-footer">
    <div class="account-panel-footer-toggle" *ngIf="showThemeToggle()">
      <sh-toggle
        [value]="themeMode.mode() === 'next'"
        (valueChange)="themeMode.toggle()"
        ariaLabel="shell.accountPanel.newLook"
      ></sh-toggle>
      <span>{{ 'shell.accountPanel.newLook' | translate }}</span>
    </div>
    <button type="button" class="account-panel-logout" (click)="logOut()">
      {{ 'shell.accountPanel.logOut' | translate }}
    </button>
  </div>
</sh-popover>
